import React, { useEffect } from 'react';
import { List, Datagrid, TextField, FunctionField } from 'react-admin';
import VideoFileIcon from '@mui/icons-material/VideoFile';

function TarjetasInicioList(props: any) {
  useEffect(() => {
    document.title = 'Tarjetas Inicio - Gasco';
  }, []);

  return (
    <List {...props}>
      <Datagrid rowClick="edit">
        <TextField source="titulo" label="Título" />
        <FunctionField
          label="Portada (Img/Vid)"
          render={(record: any) => {
            if (!record.portada) return null;
            // Verificar si es video o imagen por la extensión o mime
            const isVideo = record.portada.mime?.includes('video');
            return isVideo ? (
              <VideoFileIcon color="primary" />
            ) : (
              <img src={record.portada.url} style={{ width: '80px', height: '45px', objectFit: 'cover' }} />
            );
          }}
        />
        <FunctionField
          label="Video Principal"
          render={(record: any) => record.video ? <VideoFileIcon color="action" /> : '---'}
        />
      </Datagrid>
    </List>
  );
}

export default TarjetasInicioList;